import { List } from 'antd';
import { TabPaneContainer } from '../styles';
import { Cause, Issue, QueryType } from '../../../../types';
import ToBeReviewItem from '../../../../components/toBeReviewItem';
import { useState, useRef } from 'react';
import { fetchNotifications } from '../../../../slices/notifications';
import { useAppDispatch } from '../../../../store';
import SuggestionReviewDrawer from '../../../../components/suggestionReviewDrawer';
import { fetchTemplateRoutines } from '../../../../slices/templates';

const Causes = ({ causes }: { causes: Cause[] }) => {
  const dispatch = useAppDispatch();
  const [showReviewDrawer, setShowReviewDrawer] = useState(false);
  const currentItem = useRef<Cause>(null);

  const handleReviewDrawerClose = (isSubmitted?: boolean) => {
    setShowReviewDrawer(false);
    if (isSubmitted) {
      dispatch(fetchNotifications());
      dispatch(
        fetchTemplateRoutines({
          templateId: String(currentItem.current?.templateID),
        })
      );
    }
  };
  return (
    <TabPaneContainer>
      <List
        pagination={false}
        dataSource={causes}
        renderItem={(item, index) => (
          <ToBeReviewItem
            name={item.templateName}
            description={item.name}
            onClick={() => {
              setShowReviewDrawer(true);
              currentItem.current = item;
            }}
          />
        )}
        // footer={
        //   causes?.length > 3 ? (
        //     <Flex align="center" justify="center">
        //       <Button type="text">Load more</Button>
        //     </Flex>
        //   ) : null
        // }
      />
      {currentItem.current && (
        <SuggestionReviewDrawer
          visible={showReviewDrawer}
          onClose={handleReviewDrawerClose}
          queryType={QueryType.CASUE}
          data={currentItem.current as Cause}
        />
      )}
    </TabPaneContainer>
  );
};

export default Causes;
